import React from "react";
import {Card, CardBody, CardFooter, CardHeader, CardImg, CardImgOverlay, Col, Container, Row,} from "reactstrap";
import ProgressiveImage from "react-progressive-image";
import ButtonDesign from "../ButtonDesign";
import BroadCastTitle from "../BroadCastTitle";
import {getAgeGroupDiv, getFormattedPrice} from "../../util/utility";
import classNames from "classnames";
import assets from "../../util/assets";

const ViewCardComponent = (props) => {

    let requestGroupType =
        props.request &&
        props.request.find((req) => {
            return req.request_type === "group";
        });
    let requestOneToOneType =
        props.request &&
        props.request.find((req) => {
            return req.request_type === "onetoone";
        });
    return (
        <React.Fragment>
            <Container className="px-0">
                <Card className="border border-0 mb-4">
                    <CardHeader
                        className="border-0 px-0 pt-0"
                        style={{backgroundColor: "#F7F7F7"}}
                    >
                        <Row>
                            <Col sm="6" className="text-left">
                                <BroadCastTitle
                                    userName={props.userName}
                                    userImage={props.profilePic}
                                    status={props.status}
                                    isTitle={true}
                                />
                            </Col>

                            <Col sm="6" className="text-right">

                                <ButtonDesign
                                    btName={props.followUnfollow}
                                    btColor="link"
                                    btClass="text-decoration-none bg-white rounded-0 followbtn btn-with-shadow"
                                    onclickFunction={() => props.onClickFollow()}>
                                    {
                                        props.followUnfollow === "Follow" ?
                                            <i className="fas fa-plus" style={{paddingRight: 6}}/> :
                                            <i className='fas fa-times' style={{paddingRight: 6}}/>
                                    }
                                </ButtonDesign>

                                <ButtonDesign
                                    btId="broadcaster-detail-tip"
                                    btColor="link"
                                    btClass="text-decoration-none bg-white rounded-0 btn-with-shadow btn-tip-with-blue-bg broadcaster-detail-tip"
                                    onclickFunction={() => props.showRequestTipModal()}>
                                    <img height={23} src={assets.tip_with_blue_bg} />
                                </ButtonDesign>

                                {/*<ButtonDesign*/}
                                    {/*btColor="primary"*/}
                                    {/*btClass="mx-2 rounded-0"*/}
                                    {/*onclickFunction={() => props.showRequestTipModal()}*/}
                                {/*>*/}
                                    {/*<img className="share-availability-icon" src={assets.tip_with_blue_bg} />*/}
                                {/*</ButtonDesign>*/}

                                {(props.type && props.type === "available") ||
                                (props.type && props.type === "awaiting") ||
                                (props.type && props.type === "offline") ||
                                (props.status && props.status == 0) ? null : (
                                    <ButtonDesign
                                        btName={props.viewerCount > 0 ? props.viewerCount : 0}
                                        btColor="light"
                                        btClass="bg-white ml-3 rounded-0 userbtn btn-with-shadow"
                                    >
                                        <i className="fas fa-user-friends fa-lg mr-1"></i>
                                    </ButtonDesign>
                                )}
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody className="p-0">
                        <div className="img-fluid position-relative">
                            <ProgressiveImage
                                delay={1000}
                                src={props.channelImage}
                                placeholder="placeholder"
                            >
                                {(src, loading) => {
                                    return loading ? (
                                        props.placeholderDiv
                                    ) : (
                                        <React.Fragment>
                                            <CardImg
                                                width="100"
                                                // className={props.status !== "offline" ? (props.type && props.type !== "awaiting" ? "rounded" : "offline-image") : "offline-image"}
                                                className={
                                                    props.status !== "offline"
                                                        ? "rounded"
                                                        : "offline-image"
                                                }
                                                src={props.channelImage}
                                                alt="Card"
                                            />
                                            <CardImgOverlay>
                                                {props.status !== "offline" ? (
                                                    <React.Fragment>
                                                        <CardImgOverlay>
                                                            <div
                                                                className={classNames({
                                                                    'position-absolute': true,
                                                                    'broadcast-current-status-rectangle': true,
                                                                    'broadcast-current-status-live': props.type === "live",
                                                                    'broadcast-current-status-private': props.type === "private",
                                                                    'broadcast-current-status-awaiting': props.type === "awaiting",
                                                                    'broadcast-current-status-available': props.type === "available"
                                                                })}
                                                                style={{top: 0, right: 0}}>
                                                                <h5 className={"broadcast-current-status-title"}>
                                                                    {
                                                                        props.type === "awaiting" ? "Awaiting confirmation" : props.type
                                                                    }
                                                                </h5>
                                                            </div>
                                                        </CardImgOverlay>
                                                        {props.type && props.type !== "offline" && (
                                                            <ButtonDesign
                                                                btName={
                                                                   !props.join_broadcast.isFetching &&
                                                                       (
                                                                           props.type && props.type === "available"
                                                                               ? "Request a session"
                                                                               : props.type && props.type === "awaiting"
                                                                               ? "Awaiting Confirmation"
                                                                               : props.type && props.type === "live"
                                                                                   ? "Join Broadcast"
                                                                                   : props.type && props.type === "private"
                                                                                       ? "In private session"
                                                                                       : ""
                                                                       )
                                                                }
                                                                btColor="primary"
                                                                btClass={
                                                                    props.type && props.type === "awaiting"
                                                                        ? "position-absolute rounded-0 btnprimarydefault bg-white text-secondary border-0 broadcast-button"
                                                                        : props.type && props.type === "private"
                                                                        ? "position-absolute rounded-0 btnprimarydefault border-0 broadcast-button"
                                                                        : "position-absolute rounded-0 btnprimarydefault"
                                                                }
                                                                btStyle={
                                                                    props.type && props.type === "private"
                                                                        ? "bottom: '30px', right: '25px', opacity: 1"
                                                                        : "bottom: '30px', right: '25px',"
                                                                }
                                                                btDisable={
                                                                    props.type && props.type === "awaiting"
                                                                        ? true
                                                                        : props.type && props.type === "private"
                                                                        ? true
                                                                        : false
                                                                }
                                                                onclickFunction={() =>
                                                                    props.type && props.type === "available"
                                                                        ? props.showRequestModal()
                                                                        : props.type && props.type === "live"
                                                                        ? props.onClickJoinBroadcast()
                                                                        : null
                                                                }
                                                            >
                                                                {props.type && props.type === "awaiting" && (
                                                                    <img
                                                                        src={assets.awaiting_stopwatch}
                                                                        style={{height: 25, width: 25}}
                                                                        className="mr-2"
                                                                    />
                                                                )}
                                                                {
                                                                    props.join_broadcast.isFetching && <img src={assets.loading_white} alt={"Loading"} width={25} height={25}/>
                                                                }
                                                            </ButtonDesign>
                                                        )}
                                                    </React.Fragment>
                                                ) : (
                                                    <div className="offline-overlay">
                                                        {props.broadcasterStatusOverlay}
                                                    </div>
                                                )}
                                            </CardImgOverlay>
                                        </React.Fragment>
                                    );
                                }}
                            </ProgressiveImage>
                        </div>
                    </CardBody>
                    <CardFooter className="bg-white border-0">
                        {(props.type && props.type === "available") ||
                        (props.type && props.type === "awaiting") ? (
                            <div className="row">
                                <div className="col-sm-9">
                                    <p className="font-weight-bold no-margin">{props.sessionTitle}</p>
                                    <p className="card-text"
                                       style={{marginTop: 10, marginBottom: 10}}>{props.sessionDescription}</p>
                                </div>
                                <div className="col-sm-3 no-margin no-padding" style={{textAlign:'right'}}>
                                    <div>
                                                <span style={{fontSize: "11px"}}
                                                      className="badge badge-sm premium-badge text-white">
                                                {props && props.hasOwnProperty("groupSession") && props.groupSession !== "Free" ? "PREMIUM" : null}
                                                </span>
                                        <span style={{fontSize: "11px"}}
                                              className="ml-2 badge badge-sm text-white">
                                                    {
                                                        getAgeGroupDiv(props.broadcaster && props.broadcaster.age_group)
                                                    }
                                                    </span>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <React.Fragment>
                                {props.type && props.type !== "offline" && (
                                    <React.Fragment>
                                        <div style={{display: 'flex',justifyContent: 'space-between'}}>
                                            <p className="font-weight-bold">{props.sessionTitle}</p>
                                            <div>
                                                <span style={{fontSize: "11px"}}
                                                      className="badge badge-sm premium-badge text-white">
                                                {props && props.hasOwnProperty("groupSession") && props.groupSession !== "Free" ? "PREMIUM" : null}
                                                </span>
                                                <span style={{fontSize: "11px"}}
                                                      className="ml-2 badge badge-sm text-white">
                                                    {
                                                        getAgeGroupDiv(props.broadcaster && props.broadcaster.age_group)
                                                    }
                                                    </span>
                                            </div>
                                        </div>

                                        <p className="card-text">{props.sessionDescription}</p>
                                    </React.Fragment>
                                )}
                                <p className="font-weight-bold">
                                    {props.userName} channel description
                                </p>
                                <p className="card-text">
                                    {props.broadcaster && props.broadcaster.channel_description}
                                </p>
                            </React.Fragment>
                        )}
                        {((props.type && props.type === "live") ||
                            (props.type && props.type === "private")) && (
                            <React.Fragment>
                                <p className="font-weight-bold">
                                    Charge:{" "}
                                    {props.groupSession === "Free"
                                        ? "Free session"
                                        : props.groupSession + "p per min"}
                                </p>
                            </React.Fragment>
                        )}
                        {((props.type && props.type === "awaiting") ||
                            (props.type && props.type === "available")) && (
                            <React.Fragment>
                                <p className="font-weight-bold">Available Session Type</p>
                                <Row className="mx-1">
                                    {props.allowOneToOne !== "N/A" ? (
                                        <Col
                                            md={6}
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                            }}
                                            className="px-0 mb-2"
                                        >
                                            <div
                                                style={{
                                                    padding: 10,
                                                    fontSize: 14,
                                                    fontWeight: 600,
                                                    color: "#58595B",
                                                    backgroundColor: "#f7f7f7",
                                                    minWidth: 260,
                                                }}
                                            >
                                                <img
                                                    src={assets.one_to_one_icon_blue_bg}
                                                    style={{width: "33px"}}
                                                    className="mr-2"
                                                />
                                                1-on-1 session
                                                <span
                                                    className="text-primary font-weight-bold ml-2">{getFormattedPrice(props.allowOneToOne,true)}</span>
                                                {
                                                    requestOneToOneType ? (
                                                        <span className="text-primary badge-font ml-2 withdraw-button"
                                                        onClick={() => {
                                                            props.setWithdrawType("onetoone");
                                                            props.showConfirmationModal();
                                                        }}>Withdraw</span>
                                                ) : props.type && props.type === "awaiting" && (
                                                    <span
                                                        className="text-primary badge-font ml-2 withdraw-button"
                                                        onClick={() => {
                                                            props.showRequestModal()
                                                        }}>Request</span>
                                                )}
                                            </div>
                                            {/* {true && <span className="text-white ml-2" style={{ backgroundColor: "#1B75BC" }}>X</span>} */}
                                        </Col>
                                    ) : null}
                                    <Col
                                        md={6}
                                        style={{display: "flex", justifyContent: "space-between"}}
                                        className="px-0 mb-2"
                                    >
                                        <div style={{
                                                padding: 10,
                                                fontSize: 14,
                                                fontWeight: 600,
                                                color: "#58595B",
                                                backgroundColor: "#f7f7f7",
                                                minWidth: 260,
                                        }}>
                                            <img src={assets.group_icon_blue_bg} style={{width: "33px"}} className="mr-2"/>
                                            Group Session


                                            <span className="text-primary font-weight-bold ml-2">{getFormattedPrice(props.groupSession,true)}</span>
                                            {
                                                requestGroupType ? (
                                                    <span className="text-primary badge-font ml-2 withdraw-button"
                                                          onClick={() => {
                                                              props.setWithdrawType("group");
                                                              props.showConfirmationModal("group");
                                                          }}>Withdraw</span>
                                                ) : props.type && props.type === "awaiting" && (
                                                    <span
                                                        className="text-primary badge-font ml-2 withdraw-button"
                                                        onClick={() => {
                                                            props.showRequestModal()
                                                        }}>Request</span>
                                                )}
                                        </div>
                                    </Col>
                                </Row>
                            </React.Fragment>
                        )}
                        <Row className="mt-1">
                            <Col>
                                <p className="font-weight-bold">{props.userName}'s Tags</p>
                                <p>{props.tags}</p>
                            </Col>
                        </Row>
                    </CardFooter>
                </Card>
            </Container>
        </React.Fragment>
    );
};

export default ViewCardComponent;
